export * from './app-breadcrumbs.component';



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-proinvel-pipeline/src/app/components/app-breadcrumbs/index.ts